import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { Table } from "@opensea/ui-kit"
import { ReceiptDisplay } from "../../../../components/Receipt"
import type { Item } from "../../../../types"
import type { MintFlowView } from "../types"
import {
  MintTableCollectionFragment,
  MintTableDropFragment,
} from "./MintTable.fragment"
import { MintTableRow } from "./MintTableRow"
import { MintTableTotal } from "./MintTableTotal"

type Props = {
  collection: FragmentOf<typeof MintTableCollectionFragment>
  drop: FragmentOf<typeof MintTableDropFragment>
  tokenInputs: Item[]
  view: MintFlowView
}

export const MintTable = ({
  collection: collectionKey,
  drop: dropKey,
  tokenInputs,
  view,
}: Props) => {
  const collection = readFragment(MintTableCollectionFragment, collectionKey)
  const drop = readFragment(MintTableDropFragment, dropKey)

  const receipt = (
    <Table
      context={{ tokenInputs, view }}
      itemKey={item => item?.collection.id}
      items={[{ collection, drop }]}
      renderRow={MintTableRow}
      size="xl"
    />
  )

  const receiptTotal = (
    <Table
      itemKey={(_, index) => index}
      items={[{}]}
      renderRow={() => (
        <MintTableTotal
          collection={collection}
          drop={drop}
          tokenInputs={tokenInputs}
        />
      )}
    />
  )

  return <ReceiptDisplay receipt={receipt} receiptTotal={receiptTotal} />
}
